export enum InsightsChartType {
  incidentCounts = 'incidentCounts',
  incidentsByMotivation = 'incidentsByMotivation',
  geoLocationsMap = 'geoLocationsMap',
  geoLocationsCountries = 'geoLocationsCountries',
  geoLocationsContinents = 'geoLocationsContinents',
  incidentsByThreatActor = 'incidentsByThreatActor',
  incidentsByBusinessSector = 'incidentsByBusinessSector',
  incidentsByEntitySize = 'incidentsByEntitySize',
  rimsTechnicalInitialAccess = 'rimsTechnicalInitialAccess',
  rimsPostExploitation = 'rimsPostExploitation',
  rimsTechnicalImpact = 'rimsTechnicalImpact',
  rimsNonTechnicalImpact = 'rimsNonTechnicalImpact',
}

export const InsightsChartDescriptor = Object.freeze({
  [InsightsChartType.incidentCounts]: 'Incident counts for period',
  [InsightsChartType.incidentsByMotivation]: 'Incidents by motivation',
  [InsightsChartType.geoLocationsMap]: 'Incidents by geo location map',
  [InsightsChartType.geoLocationsCountries]: 'Incidents by geo location countries',
  [InsightsChartType.geoLocationsContinents]: 'Incidents by geo location continents',
  [InsightsChartType.incidentsByThreatActor]: 'Incidents by threat actor',
  [InsightsChartType.incidentsByBusinessSector]: 'Incidents by business sector',
  [InsightsChartType.incidentsByEntitySize]: 'Incidents by entity size',
  [InsightsChartType.rimsTechnicalInitialAccess]: 'Technical Initial Access',
  [InsightsChartType.rimsPostExploitation]: 'Post Exploitation',
  [InsightsChartType.rimsTechnicalImpact]: 'Technical Impact',
  [InsightsChartType.rimsNonTechnicalImpact]: 'Non-Technical Impact',
});

export const InsightsChartSectionName = Object.freeze({
  [InsightsChartType.incidentCounts]: 'incident-count',
  [InsightsChartType.incidentsByMotivation]: 'motivation',
  [InsightsChartType.geoLocationsMap]: 'geo-locations-map',
  [InsightsChartType.geoLocationsCountries]: 'geo-locations-countries',
  [InsightsChartType.geoLocationsContinents]: 'geo-locations-continents',
  [InsightsChartType.incidentsByThreatActor]: 'threat-actor',
  [InsightsChartType.incidentsByBusinessSector]: 'affected-entity-business-sector',
  [InsightsChartType.incidentsByEntitySize]: 'affected-entity-size',
  [InsightsChartType.rimsTechnicalInitialAccess]: 'rims-technical-initial-access',
  [InsightsChartType.rimsPostExploitation]: 'rims-post-exploitation',
  [InsightsChartType.rimsTechnicalImpact]: 'rims-technical-impact',
  [InsightsChartType.rimsNonTechnicalImpact]: 'rims-non-technical-impact',
});
